<template>
  <vs-popup class="customer-bespoke-price-tiers-popup"
            title="CUSTOMER BESPOKE PRICE TIERS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="bespoke-price-create-tiers" @submit.prevent="handleSubmit(onClickCreateCustomerBespokePrice)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_code" name="formulation_code" rules="required" v-slot="{ errors }">
                <small class="label">ITS PRODUCT CODE</small>
                <vs-input disabled v-model="formulation_data.formulation_code" name="formulation_code" class="w-full"
                          label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full text-center">
              <vs-alert :color="formulation_data.using_default_pricing ? 'warning' : 'primary'" class="h-auto font-bold">
                {{ formulation_data.using_default_pricing ? "M&F Pricing - This product uses standard costings" : "M&F Pricing - This product uses actual costings" }}
              </vs-alert>
            </div>
          </div>

          <vx-card no-shadow title="Price Tiers">
          <vs-list>
            <draggable :list="payload.tiers">
            <transition-group>
            <vs-list-item class="p-1 mb-4 w-full" v-for="(prices_tier, index) in payload.tiers" :key="index+'1'">
                <div class="w-full">
                  <div v-if="checkGapBetweenTiers(index)" class="w-full mb-3">
                    <vx-card cardBorder class="w-full">
                      <div class="vx-row items-center">
                        <div class="vx-col w-4/5 text-warning font-bold">
                          There is a gap between {{ index === 0 ? 1 : payload.tiers[index - 1].to }} - {{ payload.tiers[index].from }} KG. Click the button to fix it.
                        </div>
                        <div class="vx-col w-1/5 text-right">
                          <vs-button @click.stop="onClickFillGaps(index)" size="small" color="warning">+ Add</vs-button>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                  <table class="w-full">
                    <tbody>
                    <tr>
                      <td style="width: 25%;">
                        <div class="vx-row px-4 mb-4 mr-2">
                          <ValidationProvider :vid="index+'from'" :name="index+'from'" :rules="validate_prices_tier(index)"
                                              v-slot="{ errors }">
                            <vs-input label-placeholder="Quantity from (Kg)"  v-model="prices_tier.from" type="number" step="0.01" name="from" class="w-full"
                                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                      val-icon-pack="feather"/>
                          </ValidationProvider>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <ValidationProvider :vid="index+'to'" :name="index+'to'" :rules="validate_max_price_tier(index)"
                                              v-slot="{ errors }">
                            <vs-input label-placeholder="Quantity to (Kg)"  v-model="prices_tier.to" type="number" step="0.01" name="to" class="w-full" :danger="!!errors[0]"
                                      :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                        </div>
                      </td>
                      <td style="width: 25%;">
                        <div class="vx-row px-4 mb-4 mr-2">
                          <vs-input :label-placeholder="`Guide price from (${account_currency}/KG)`"
                                    readonly :value="calculateProductListPrice(formulation_data.pe_g, prices_tier.from, formulation_data.fx_rate, is_shipping_cost_enable)" name="fromPrice" class="w-full"/>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <vs-input :label-placeholder="`Guide price to (${account_currency}/KG)`"
                                    readonly :value="calculateProductListPrice(formulation_data.pe_g, prices_tier.to, formulation_data.fx_rate, is_shipping_cost_enable)" name="toPrice" class="w-full"/>
                        </div>
                      </td>
                      <td style="width: 22%;">
                        <ValidationProvider :vid="index+'price'" :name="index+'price'" rules="required" v-slot="{ errors }">
                          <vs-input :label-placeholder="`Bespoke price (${account_currency}/KG)`" v-model="prices_tier.price" type="text" name="price" class="w-full" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </td>
                      <td style="width: 20%;">
                        <div class="vx-row px-4 mb-4 mr-2">
                          <vs-input label-placeholder=" Gross Margin % "
                                    readonly :value="calculateGrossMargin(formulation_data.pe_g, prices_tier.from, prices_tier.price, is_shipping_cost_enable, formulation_data.fx_rate)" type="text" name="fromPrice" class="w-full"/>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <vs-input label-placeholder=" Gross Margin % "
                                    readonly :value="calculateGrossMargin(formulation_data.pe_g, prices_tier.to, prices_tier.price, is_shipping_cost_enable, formulation_data.fx_rate)" name="toPrice" class="w-full"/>
                        </div>
                      </td>
                      <td style="width: 4%;">
                        <vs-button :disabled="payload.tiers.length === 1" class="ml-3" @click="deletePriceTier(index)" size="small"
                                   color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                      </td>
                      <td style="width: 4%;">
                        <feather-icon icon="AlignJustifyIcon" class="cursor-pointer ml-4 mr-6 mt-1 w-8" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </vs-list-item>
            </transition-group>
            </draggable>
          </vs-list>
          </vx-card>

          <!-- <vs-table stripe :hoverFlat="true" :data="payload.tiers">

            <template slot="header">
              <h5 class="mt-4 mb-2">Price tiers</h5>
            </template>

            <template slot="thead">
              <vs-th></vs-th>
              <vs-th></vs-th>
              <vs-th>Bespoke price ({{account_currency}}/KG)</vs-th>
              <vs-th>Gross margin %</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <draggable :list="data">
              <transition-group>
              <vs-tr style="border-bottom: 1pt solid #d8ded8;" :key="index" v-for="(prices_tier, index) in data">

                <vs-td>
                  <div class="vx-row px-4 mb-4">
                    <ValidationProvider :vid="index+'from'" :name="index+'from'" :rules="validate_prices_tier(index)"
                                        v-slot="{ errors }">
                      <vs-input label-placeholder="Quantity from (Kg)"  v-model="prices_tier.from" type="number" step="0.01" name="from" class="w-full"
                                :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-row px-4">
                    <ValidationProvider :vid="index+'to'" :name="index+'to'" :rules="validate_max_price_tier(index)"
                                        v-slot="{ errors }">
                      <vs-input label-placeholder="Quantity to (Kg)"  v-model="prices_tier.to" type="number" step="0.01" name="to" class="w-full" :danger="!!errors[0]"
                                :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </vs-td>

                <vs-td>
                  <div class="vx-row px-4 mb-4">
                    <vs-input :label-placeholder="`Guide price from (${account_currency}/KG)`" type="number" name="fromPrice" class="w-full"
                      readonly :value="calculateProductListPrice(formulation_data.pe_g, prices_tier.from, formulation_data.fx_rate, is_shipping_cost_enable)"/>
                  </div>
                  <div class="vx-row px-4">
                    <vs-input :label-placeholder="`Guide price to (${account_currency}/KG)`" name="toPrice" class="w-full"
                      readonly :value="calculateProductListPrice(formulation_data.pe_g, prices_tier.to, formulation_data.fx_rate, is_shipping_cost_enable)"/>
                  </div>
                </vs-td>

                <vs-td>
                  <ValidationProvider :vid="index+'price'" :name="index+'price'" rules="required" v-slot="{ errors }">
                    <vs-input v-model="prices_tier.price" type="text" name="price" class="w-full" :danger="!!errors[0]"
                              :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td>
                  <div class="vx-row px-4 mb-4">
                    <vs-input label-placeholder=" "
                              readonly :value="calculateGrossMargin(formulation_data.pe_g, prices_tier.from, prices_tier.price, is_shipping_cost_enable, formulation_data.fx_rate)" type="text" name="fromPrice" class="w-full"/>
                  </div>
                  <div class="vx-row px-4">
                    <vs-input label-placeholder=" "
                              readonly :value="calculateGrossMargin(formulation_data.pe_g, prices_tier.to, prices_tier.price, is_shipping_cost_enable, formulation_data.fx_rate)" name="toPrice" class="w-full"/>
                  </div>
                </vs-td>


                <vs-td>
                  <vs-button :disabled="payload.tiers.length === 1" class="" @click="deletePriceTier(index)" size="small"
                             color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                </vs-td>
              </vs-tr>
              </transition-group>
              </draggable>
            </template>

          </vs-table> -->

          <vs-button @click="addPriceTier" size="small" color="success" type="filled" icon-pack="feather" class="mt-4"
                     icon="icon-plus">Add prices tier
          </vs-button>


          <div class="vx-row mt-8 mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="note" name="note" rules="required" v-slot="{ errors }">
                <small class="label">Incoterm</small>
                <!-- <v-select :append-to-body="true"
                          :clearable="true" name="incoterms" placeholder=""
                          v-model="payload.incoterm"
                          label="code"
                          :reduce="option => option.code"
                          :options="incoterms" :dir="$vs.rtl ? 'rtl' : 'ltr'"/> -->
                <select v-model="payload.incoterm" class="default-dropdown">
                  <option v-for="option in incoterms" :value="option.code">
                    {{ option.code }}
                  </option>
                </select>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2" v-if="is_shipping_cost_enable">
              <br>
              <span class="text-danger">*Please note this incoterm will add shipping to your margin calculation above and will reduce margin compared to EXW</span> 
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="payload.note" height="100px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Calculations from '@/mixins/Calculations'

const CustomerRepository = RepositoryFactory.get('customer')
const IncotermRepository = RepositoryFactory.get('incoterm');
const PricingTierRepository = RepositoryFactory.get('pricing_tier');
const SprayDryCostRepository = RepositoryFactory.get('spray_dry_cost');
import draggable from 'vuedraggable'

function initialState() {
  return {
    open: false,
    payload: {
      tiers: []
    },
    formulation_data: {},
    incoterms: [],
  }
}

export default {
  name: 'CustomerBepokePriceTiersPopUp',
  data() {
    return initialState()
  },
  props: {
    account_currency: {
      type: String,
      default: '',
    }
  },
  methods: {
    async openPopup(payload, data) {
      try {
        Object.assign(this.$data, initialState())
        this.open = true;
        this.payload = payload
        this.formulation_data = data
        await this.fetchIncoterms()
        await this.fetchPreSetPricingTiers()
      } catch (error) {

      }
    },
    async onClickCreateCustomerBespokePrice() {
      const vue = this;
      await this.$vs.loading({
        container: `#bespoke-price-create-tiers`,
        scale: 0.45
      })
      try {
        this.payload.tiers = this.payload.tiers.map((n) => {
          let obj = {}
          obj.to = n.to
          obj.from = n.from
          obj.price = Number(n.price).toFixed(2)
          return obj
        })
        this.payload.shipping_cost = this.is_shipping_cost_enable ?  Number(this.formulation_data.pe_g.rseq5).toFixed(2) : '0.00'
        await CustomerRepository.addCustomerBespokePrice(this.payload)
        this.showSuccessMessage('bespoke price created successfully')
        await vue.$emit('refreshData', '');
        this.open = false;
      } catch (e) {
        this.$vs.loading.close(`#bespoke-price-create-tiers > .con-vs-loading`)
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close(`#bespoke-price-create-tiers > .con-vs-loading`)
    },
    async fetchIncoterms() {
      try {
        const {data} = (await IncotermRepository.getListOfIncoterms(1, '', 100, '')).data
        this.incoterms = data
        const default_incoterm = this.incoterms.find((x) => x.is_default)
        this.payload.incoterm = default_incoterm ? default_incoterm.code : null
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },

    onChangeQty(qty, index, input_box) {
      this.updateListPrice(qty, index, input_box ,this)
    },

    updateListPrice: _.debounce( async (qty, index, input_box ,vm) => {
      vm.payload.tiers[index][input_box] = vm.calculateProductListPrice(vm.formulation_data.gbp_price, qty)
    }, 500),

    validate_prices_tier(index) {
      let previousIndex = index - 1
      // return `min_than:@${index}to|cross_over_max:@${previousIndex}to|required`
      return `min_than_or_equal:@${index}to|cross_over_max_equal:@${previousIndex}to|required`
    },

    validate_max_price_tier(index) {
      // return `max_than:@${index}from|required`
      return `max_than_or_equal:@${index}from|required`
    },

    addPriceTier() {
      this.payload.tiers.push(
        {from: null, to: null, price: null, fromPrice: null, toPrice: null}
      )
    },

    deletePriceTier(index) {
      this.payload.tiers.splice(index, 1)
    },

    calculatePositionFun() {

    },
    async fetchPreSetPricingTiers() {
      try {
        if (this.formulation_data && this.formulation_data.formulation_type === 'spray dry powder') {
          const response = (await SprayDryCostRepository.getTollDryingYieldRangesList(1, '', 100)).data
          const list = response.data.sort((a, b) => Number(a.order) - Number(b.order))
          if (list.length === 0) {
            this.payload.tiers.push({
              from: null,
              to: null,
              price: null,
              fromPrice: null,
              toPrice: null,
            })
          } else {
            this.payload.tiers = list.map((x) => {
              return {
                from: x.min_value,
                to: x.max_value,
                price: null,
                fromPrice: null,
                toPrice: null,
              }
            })
          }
        } else {
          const res = (await PricingTierRepository.getPricingTierList(1, 'filter[type]=bespoke-pricing', 50)).data
          const responseData = res.data || res
          const bespokeTiers = responseData['bespoke-pricing'] || {}
          const formulationType = this.formulation_data ? this.formulation_data.formulation_type : null
          const data = (formulationType && bespokeTiers[formulationType]) ? bespokeTiers[formulationType] : []
          if (!data || data.length === 0) {
            this.payload.tiers.push({
              from: null,
              to: null,
              price: null,
              fromPrice: null,
              toPrice: null,
            })
          } else {
            this.payload.tiers = data.map((x) => {
              return {
                from: x.from,
                to: x.to,
                price: null,
                fromPrice: null,
                toPrice: null,
              }
            })
          }
        }
      } catch (error) {
        
      }
    },
    checkGapBetweenTiers(index) {
      if(index === 0) {
        const fromVal = Number(this.payload.tiers[index].from)
        return fromVal !== 1 && fromVal !== 0
      }
      if(!this.payload.tiers[index - 1].to || !this.payload.tiers[index].from) {
        return false
      }
      return Number(this.payload.tiers[index - 1].to) !== Number(this.payload.tiers[index].from)
    },
    onClickFillGaps(index) {
      let from = index === 0 ? 1 :  Number(this.payload.tiers[index - 1].to)
      let to = Number(this.payload.tiers[index].from)
      this.payload.tiers.splice(index, 0, { from: from + '', to: to + '', price: null })
    }
  },
  computed: {
    is_shipping_cost_enable() {
      const find = this.incoterms.find((x) => this.payload.incoterm === x.code)
      return find ? find.is_price_included : false
    }
  },
  components: {
    'v-select': vSelect,
    draggable
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
.customer-bespoke-price-tiers-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 60% !important;
}

.customer-bespoke-price-tiers-popup >>> .vs-list--item {
  display: block !important;
  width: 100% !important;
  padding: 0 !important;
}

.customer-bespoke-price-tiers-popup >>> .vs-list--slot {
  margin-left: 0 !important;
  width: 100% !important;
}

</style>
